import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Tooltip,
  Typography,
  IconButton,
  AppBar,
  Toolbar,
  Avatar,
  Menu,
  MenuItem,
  Divider,
} from "@mui/material";
import { useAuth } from "../context/AuthContext";
import logo from "../Icons/06 Bloomwatch Logo 1.1 1.png";
import BellIcon from "../Icons/Bell.svg";
import Login from "../Icons/BloomWatch Icons V2.3/LogNAct.svg";

// Main Menu Icons
import HomeIcon from "../Icons/BloomWatch Icons V2.3/Hom_1.svg";
import HomeHoverIcon from "../Icons/BloomWatch Icons V2.3/HomAct_1.svg";
import JobmonitoringIcon from "../Icons/BloomWatch Icons V2.3/JobMntr_1.svg";
import JobmonitoringHoverIcon from "../Icons/BloomWatch Icons V2.3/JobMntrAct_1.svg";
import FailureIcon from "../Icons/BloomWatch Icons V2.3/FalrTrk_1.svg";
import FailureHoverIcon from "../Icons/BloomWatch Icons V2.3/FalrTrkAct_1.svg";
import MasterIcon from "../Icons/BloomWatch Icons V2.3/Mastr_1.svg";
import MasterHoverIcon from "../Icons/BloomWatch Icons V2.3/MastrAct_1.svg";
import ConnectorIcon from "../Icons/BloomWatch Icons V2.3/Conct_1.svg";
import ConnectorHoverIcon from "../Icons/BloomWatch Icons V2.3/ConctAct_1.svg";
import BloomAiIcon from "../Icons/BloomWatch Icons V2.3/BlmAI_1.svg";
import BloomAiHoverIcon from "../Icons/BloomWatch Icons V2.3/BlmAIAct_1.svg";
import SettingsIcon from "../Icons/BloomWatch Icons V2.3/Setng_1.svg";
import SettingsHoverIcon from "../Icons/BloomWatch Icons V2.3/SetngAct_1.svg";
import HelpIcon from "../Icons/BloomWatch Icons V2.3/Hlp_1.svg";
import HelpHoverIcon from "../Icons/BloomWatch Icons V2.3/HlpAct_1.svg";
import ProcessIcon from "../Icons/Process monitor InAct.svg";
import ProcessIconHover from "../Icons/Process monitor Act 1.svg";
import ReportIconHover from "../Icons/Reprt BW Act.svg";
import ReportIcon from "../Icons/Reprt Inact.svg";
import TicketIconHover from "../Icons/ticket Act 1.svg";
import TicketIcon from "../Icons/ticketInAct 1.svg";
import EndpointIconHover from "../Icons/Endpoin2Act.svg";
import EndpointIcon from "../Icons/Endpoin2InAct.svg";
import connectorsIconHover from "../Icons/Connectors Act 1.svg";
import connectorsIcon from "../Icons/Connectors InAct 1.svg";
import PlayBookIconHover from "../Icons/PlaybukAct 1.svg";
import PlayBookIcon from "../Icons/PlaybukInAct 1.svg";

// Master Submenu Icons
import ClientIcon from "../Icons/Client.svg";
import ClientHoverIcon from "../Icons/Client gradient.svg";
import EnvIcon from "../Icons/Environment.svg";
import EnvHoverIcon from "../Icons/Environment Gradient.svg";
import AppIcon from "../Icons/Application.svg";
import AppHoverIcon from "../Icons/Application Gradient.svg";
import LogicalGroupsIcon from "../Icons/Logical group.svg";
import LogicalGroupsHoverIcon from "../Icons/Logical group gradient.svg";
import AlternateIcon from "../Icons/Alternative names.svg";
import AlternateHoverIcon from "../Icons/Alternative names gradient.svg";
import SubstageIcon from "../Icons/Substage.svg";
import SubstageHoverIcon from "../Icons/Substage howered.svg";
import JobsIcon from "../Icons/Jobs.svg";
import JobsHoverIcon from "../Icons/Jobs howered.svg";
import ScheduleIcon from "../Icons/Schedule.svg";
import ScheduleHoverIcon from "../Icons/Schedule gradient.svg";
import DocumentsIcon from "../Icons/Documents.svg";
import DocumentsHoverIcon from "../Icons/Documents Gradient.svg";

const Sidebar = () => {
  const { logout, user } = useAuth();
  const [openMaster, setOpenMaster] = useState(false);
  const [openReports, setOpenReports] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [activeItem, setActiveItem] = useState("");
  const [activeSubmenu, setActiveSubmenu] = useState("");
  const [avatarMenuAnchor, setAvatarMenuAnchor] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const masterButtonRef = useRef(null);
  const reportsButtonRef = useRef(null);
  const submenuRef = useRef(null);
  const reportsSubmenuRef = useRef(null);

  const menuItems = [
    { label: "Home", icon: HomeIcon, hoverIcon: HomeHoverIcon, path: "/home" },
    {
      label: "Job Monitoring",
      icon: JobmonitoringIcon,
      hoverIcon: JobmonitoringHoverIcon,
      path: "/jobmonitoring",
    },
    {
      label: "Failure Tracking",
      icon: FailureIcon,
      hoverIcon: FailureHoverIcon,
      path: "/failuretracking",
    },
    {
      label: "Process Monitoring",
     icon: ProcessIcon ,
      hoverIcon: ProcessIconHover,
      path: "/processmonitoring",
    },
    {
      label: "Master",
      icon: MasterIcon,
      hoverIcon: MasterHoverIcon,
      isMaster: true,
    },
    
     {
       label: "Reports",
      icon: ReportIcon,
      hoverIcon: ReportIconHover,
       isReports: true,
     },
    {
      label: "Bloom AI",
      icon: BloomAiIcon,
      hoverIcon: BloomAiHoverIcon,
      path: "/bloomAI",
    },
    {
      label: "Settings",
      icon: SettingsIcon,
      hoverIcon: SettingsHoverIcon,
      path: "/settings",
    },
    { label: "Help", icon: HelpIcon, hoverIcon: HelpHoverIcon, path: "/help" },
  ];

  const reportsMenuItems = [
   
    {
      name: "Job Monitoring Reports",
      icon: JobmonitoringIcon,
      hoverIcon: JobmonitoringHoverIcon,
      path: "/job-monitoring-reports",
    },
     {
      name: "Failure Tracking Reports",
      icon: FailureIcon,
      hoverIcon: FailureHoverIcon,
      path: "/failure-tracking-reports",
    },
     {
      name: "Documents",
      icon: DocumentsIcon,
      hoverIcon: DocumentsHoverIcon,
      path: "/documents",
    },
    
    {
      name: "Tickets",
      icon: TicketIcon,
      hoverIcon: TicketIconHover,
      path: "/tickets",
    },
  ];

  const masterMenuItems = [
    {
      name: "Client",
      icon: ClientIcon,
      hoverIcon: ClientHoverIcon,
      path: "/client",
    },
    {
      name: "Environments",
      icon: EnvIcon,
      hoverIcon: EnvHoverIcon,
      path: "/environments",
    },
    {
      name: "Application",
      icon: AppIcon,
      hoverIcon: AppHoverIcon,
      path: "/application",
    },
    {
      name: "Logical Groups",
      icon: LogicalGroupsIcon,
      hoverIcon: LogicalGroupsHoverIcon,
      path: "/logicalgroups",
    },
    {
      name: "Alternative Names",
      icon: AlternateIcon,
      hoverIcon: AlternateHoverIcon,
      path: "/alternativenames",
    },
    
    { name: "Jobs", icon: JobsIcon, hoverIcon: JobsHoverIcon, path: "/jobs" },
    {
      name: "Sub Stages",
      icon: SubstageIcon,
      hoverIcon: SubstageHoverIcon,
      path: "/substage",
    },
    {
      name: "Schedule",
      icon: ScheduleIcon,
      hoverIcon: ScheduleHoverIcon,
      path: "/schedule",
    },
   
    {
      name: "Connectors",
      icon: connectorsIcon,
      hoverIcon: connectorsIconHover,
      path: "/connectors-endpoints-playbooks",
    },
    {
      name: "ConnectorX",
      icon: ConnectorIcon,
      hoverIcon: ConnectorHoverIcon,
      path: "/connectors",
    },
  ];

  const handleNavigation = (path, label, isSubmenu = false) => {
    if (path) navigate(path);
    if (isSubmenu) {
      setActiveSubmenu(label);
      // Determine parent based on path
      if (path === "/failure-tracking-reports" || path === "/job-monitoring-reports") {
        setActiveItem("Reports");
      } else {
        setActiveItem("Master");
      }
    } else {
      setActiveItem(label);
      setActiveSubmenu("");
    }
    setOpenMaster(false);
    setOpenReports(false);
  };

  const handleMasterClick = (e) => {
    e.preventDefault();
    setOpenMaster((prev) => !prev);
    setOpenReports(false);
  };

  const handleReportsClick = (e) => {
    e.preventDefault();
    setOpenReports((prev) => !prev);
    setOpenMaster(false);
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
    setAvatarMenuAnchor(null);
  };

  const handleAvatarClick = (event) => {
    setAvatarMenuAnchor(event.currentTarget);
  };

  const handleAvatarMenuClose = () => {
    setAvatarMenuAnchor(null);
  };

  useEffect(() => {
    const path = location.pathname.toLowerCase();
    const pathMap = {
      "/home": "Home",
      "/jobmonitoring": "Job Monitoring",
      "/failuretracking": "Failure Tracking",
      "/processmonitoring": "Process Monitoring",
      "/failure-tracking-reports": "Reports",
      "/job-monitoring-reports": "Reports",
      "/client": "Master",
      "/environments": "Master",
      "/application": "Master",
      "/logicalgroups": "Master",
      "/alternativenames": "Master",
      "/substage": "Master",
      "/jobs": "Master",
      "/schedule": "Master",
      "/documents": "Reports",
      "/tickets": "Reports",
      "/connectors-endpoints-playbooks": "Master",
      "/connectors": "ConnectorX",
      "/bloomai": "Bloom AI",
      "/settings": "Settings",
      "/help": "Help",
    };

    const mainItem = pathMap[path];
    if (mainItem) {
      setActiveItem(mainItem);
      
      // Check if it's a master submenu item
      const masterSub = masterMenuItems.find((item) => item.path === path);
      if (masterSub) {
        setActiveSubmenu(masterSub.name);
      } else {
        // Check if it's a reports submenu item
        const reportsSub = reportsMenuItems.find((item) => item.path === path);
        if (reportsSub) {
          setActiveSubmenu(reportsSub.name);
        } else {
          setActiveSubmenu("");
        }
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        submenuRef.current &&
        !submenuRef.current.contains(event.target) &&
        masterButtonRef.current &&
        !masterButtonRef.current.contains(event.target)
      ) {
        setOpenMaster(false);
      }
      if (
        reportsSubmenuRef.current &&
        !reportsSubmenuRef.current.contains(event.target) &&
        reportsButtonRef.current &&
        !reportsButtonRef.current.contains(event.target)
      ) {
        setOpenReports(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const isActive = (label) => activeItem === label;
  const isHovered = (label) => hoveredItem === label;

  return (
    <>
      {/* Top AppBar with Authentication */}
      <AppBar
        position="fixed"
        sx={{
          left: 80,
          width: "calc(100% - 80px)",
          height: 60,
          backgroundColor: "#ffffff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          zIndex: 1300,
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            variant="h6"
            sx={{
              display: "flex",
              alignItems: "center",
              ml: 1,
            }}
          >
            <img
              src={logo}
              alt="Bloomwatch Logo"
              style={{
                width: 170,
                height: 40,
                objectFit: "contain",
              }}
            />
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <img src={BellIcon} alt="bell" style={{ width: 20, height: 20 }} />

            {/* Avatar with dropdown menu */}
            <Tooltip title={`${user?.name || "User"}`}>
              <IconButton onClick={handleAvatarClick} size="small">
                <Avatar
                  sx={{
                    width: 32,
                    height: 32,
                    backgroundColor: "#0078d4",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  {user?.name?.charAt(0)?.toUpperCase() || "U"}
                </Avatar>
              </IconButton>
            </Tooltip>

            {/* Avatar dropdown menu */}
            <Menu
              anchorEl={avatarMenuAnchor}
              open={Boolean(avatarMenuAnchor)}
              onClose={handleAvatarMenuClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              PaperProps={{
                sx: {
                  mt: 1,
                  minWidth: 200,
                  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                  borderRadius: 2,
                },
              }}
            >
              {/* User Info */}
              <Box sx={{ px: 2, py: 1.5 }}>
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: "bold", color: "#333" }}
                >
                  {user?.name || "User"}
                </Typography>
                <Typography variant="caption" sx={{ color: "#666" }}>
                  {user?.email || "user@example.com"}
                </Typography>
                {user?.client_name && (
                  <Typography
                    variant="caption"
                    sx={{ color: "#666", display: "block" }}
                  >
                    Client: {user.client_name}
                  </Typography>
                )}
              </Box>

              <Divider />

              {/* Logout Option */}
              <MenuItem
                onClick={handleLogout}
                sx={{
                  py: 1.5,
                  color: "#d32f2f",
                  "&:hover": {
                    backgroundColor: "#ffebee",
                  },
                }}
              >
                <img
                  src={Login}
                  alt="logout"
                  style={{ width: 16, height: 16, marginRight: 8 }}
                />
                Logout
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Sidebar - Exact design with smaller icons and no underline */}
      <Box
        sx={{
          position: "fixed",
          left: 0,
          top: 0,
          width: 80,
          height: "100vh",
          backgroundColor: "#f4f4f4",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          boxShadow: "2px 0 5px rgba(0,0,0,0.1)",
          zIndex: 1200,
          pt: 1,
        }}
      >
        {menuItems.map((item) => {
          const CurrentIcon =
            isActive(item.label) || isHovered(item.label)
              ? item.hoverIcon
              : item.icon;

          return (
            <Tooltip key={item.label} title={item.label} placement="right">
              <Box
                ref={item.isMaster ? masterButtonRef : item.isReports ? reportsButtonRef : null}
                component={item.isMaster || item.isReports ? "div" : Link}
                to={item.path || "#"}
                onClick={
                  item.isMaster
                    ? handleMasterClick
                    : item.isReports
                      ? handleReportsClick
                      : () => handleNavigation(item.path, item.label)
                }
                onMouseEnter={() => setHoveredItem(item.label)}
                onMouseLeave={() => setHoveredItem(null)}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "64px",
                  padding: "8px 0",
                  marginBottom: "3px",
                  borderRadius: "12px",
                  backgroundColor: isActive(item.label)
                    ? "#ffffff"
                    : isHovered(item.label)
                      ? "#e0e0e0"
                      : "transparent",
                  border: isActive(item.label) ? "3px solid #0078d4" : "none",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  textDecoration: "none",
                  "&:hover": {
                    textDecoration: "none",
                  },
                  "& a": {
                    textDecoration: "none",
                  },
                }}
              >
                <img
                  src={CurrentIcon}
                  alt={item.label}
                  style={{ width: 19, height: 19 }}
                />
                <Typography
                  variant="caption"
                  sx={{
                    mt: 0.5,
                    fontSize: 10,
                    color:
                      isActive(item.label) || isHovered(item.label)
                        ? "#0078d4"
                        : "#333",
                    textAlign: "center",
                    textDecoration: "none",
                  }}
                >
                  {item.label}
                </Typography>
              </Box>
            </Tooltip>
          );
        })}
      </Box>

      {/* Master Submenu */}
      {openMaster && (
        <Box
          ref={submenuRef}
          sx={{
            position: "fixed",
            left: 92,
            top: masterButtonRef.current
              ? masterButtonRef.current.getBoundingClientRect().top
              : 200,
            transform: "translateY(-100px)", // ← negative = move up
            width: 280,
            backgroundColor: "#ffffff",
            borderRadius: "14px",
            boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
            py: 2.5,
            px: 2.5,
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            rowGap: "13px",
            columnGap: "13px",
            zIndex: 1300,
          }}
        >
          {masterMenuItems.map((subItem) => {
            const isSubActive = activeSubmenu === subItem.name;
            const isSubHovered = hoveredItem === subItem.name;
            const IconSrc =
              isSubActive || isSubHovered ? subItem.hoverIcon : subItem.icon;

            return (
              <Box
                key={subItem.name}
                onClick={() =>
                  handleNavigation(subItem.path, subItem.name, true)
                }
                onMouseEnter={() => setHoveredItem(subItem.name)}
                onMouseLeave={() => setHoveredItem(null)}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: "8px 4px",
                  borderRadius: "10px",
                  cursor: "pointer",
                  backgroundColor: isSubHovered ? "#f5f7fa" : "transparent",
                  transition: "background 0.2s ease",
                }}
              >
                <img
                  src={IconSrc}
                  alt={subItem.name}
                  style={{
                    width: 20,
                    height: 20,
                    marginBottom: 4,
                  }}
                />

                <Typography
                  sx={{
                    fontSize: 11.5,
                    lineHeight: 1.2,
                    color: isSubActive ? "#0078d4" : "#555",
                    textAlign: "center",
                    fontWeight: isSubActive ? 600 : 400,
                  }}
                >
                  {subItem.name}
                </Typography>
              </Box>
            );
          })}
        </Box>
      )}

      {/* Reports Submenu */}
      {openReports && (
        <Box
          ref={reportsSubmenuRef}
          sx={{
            position: "fixed",
            left: 92,
            top: reportsButtonRef.current
              ? reportsButtonRef.current.getBoundingClientRect().top
              : 200,
            transform: "translateY(-20px)",
            width: 200,
            backgroundColor: "#ffffff",
            borderRadius: "14px",
            boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
            py: 2.5,
            px: 2.5,
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            rowGap: "13px",
            columnGap: "13px",
            zIndex: 1300,
          }}
        >
          {reportsMenuItems.map((subItem) => {
            const isSubActive = activeSubmenu === subItem.name;
            const isSubHovered = hoveredItem === subItem.name;
            const IconSrc =
              isSubActive || isSubHovered ? subItem.hoverIcon : subItem.icon;

            return (
              <Box
                key={subItem.name}
                onClick={() =>
                  handleNavigation(subItem.path, subItem.name, true)
                }
                onMouseEnter={() => setHoveredItem(subItem.name)}
                onMouseLeave={() => setHoveredItem(null)}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: "8px 4px",
                  borderRadius: "10px",
                  cursor: "pointer",
                  backgroundColor: isSubHovered ? "#f5f7fa" : "transparent",
                  transition: "background 0.2s ease",
                }}
              >
                <img
                  src={IconSrc}
                  alt={subItem.name}
                  style={{
                    width: 20,
                    height: 20,
                    marginBottom: 4,
                  }}
                />

                <Typography
                  sx={{
                    fontSize: 11.5,
                    lineHeight: 1.2,
                    color: isSubActive ? "#0078d4" : "#555",
                    textAlign: "center",
                    fontWeight: isSubActive ? 600 : 400,
                  }}
                >
                  {subItem.name}
                </Typography>
              </Box>
            );
          })}
        </Box>
      )}
    </>
  );
};

export default Sidebar;
